import { Box, Chip, Typography } from '@mui/material';
import { useGetIdentity, usePermissions } from 'react-admin';
import { useRegion } from '../auth/RegionContext';

/**
 * Top-bar identity readout (step 0.5): the signed-in user's email plus their
 * role and region scope, so a GLOBAL super_admin visibly differs from a UK
 * viewer. Logout stays on the default React Admin user menu (step 0.2).
 *
 * `region` here is the user's SCOPE (UK | US | GLOBAL from the token), not the
 * currently-active market — the scope is the stable identity fact.
 */
export const IdentityBadge = () => {
  const { identity } = useGetIdentity();
  const { permissions } = usePermissions();
  const { region } = useRegion();

  const email = (identity as { email?: string } | undefined)?.email ?? '';
  const role = typeof permissions === 'string' ? permissions : '—';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 1 }}>
      {email && (
        <Typography
          variant="body2"
          sx={{ color: 'inherit', display: { xs: 'none', sm: 'block' } }}
        >
          {email}
        </Typography>
      )}
      <Chip
        size="small"
        variant="outlined"
        label={`${role} · ${region}`}
        aria-label={`Role ${role}, region ${region}`}
        sx={{ color: 'inherit', borderColor: 'currentColor' }}
      />
    </Box>
  );
};
